<template>
  <div class="etab-category-component">
    <ExtraRoundedBtn
      v-for="category in categoriesDisplay"
      :key="category.getId()"
      :hide="!isCategorySelected(category.getId()) && !showAll && !category.isFavorite()"
      :label="category.getLabel()"
      :active="isCategorySelected(category.getId())"
      @click="$emit('onSelect', category)"
    />

    <QBtn
      v-show="categoriesDisplay.length > 0"
      color="secondary"
      class="full-width"
      :label="showAll ? $t('ETAB.PAGES.SIGNUP.STEPS.MAIN.CATEGORY.@SHOW_LESS') : $t('ETAB.PAGES.SIGNUP.STEPS.MAIN.CATEGORY.@SHOW_MORE')"
      flat
      no-caps
      :ripple="false"
      @click="showHideAllCategories()"
    />
  </div>
</template>
<script>
  export default {
    props: {
      selectedFamilyCategories: {
        type: Array,
        default: () => [],
      },
      selectedCategoryId: {
        type: Number,
        default: null,
      },
    },
    emits: ["onSelect"],
    data() {
      return {
        showAll: false,
      };
    },
    computed: {
      // we want to display the selected category as first item on the array
      categoriesDisplay() {
        const selectedFamilyCategories = [].concat(this.selectedFamilyCategories);
        // if there's a selected item
        if (this.selectedCategoryId !== null) {
          // save the item
          const selectedCategory = this.selectedFamilyCategories.find((c) => c.getId() === this.selectedCategoryId);
          if (selectedCategory) {
            // get the index and remove it from array
            const index = this.selectedFamilyCategories.findIndex((c) => c.getId() === this.selectedCategoryId);
            selectedFamilyCategories.splice(index, 1);
            // put it back on front
            selectedFamilyCategories.unshift(selectedCategory);
          }
        }
        return selectedFamilyCategories;
      },
    },
    created() {
      this.showAll = !this.categoriesDisplay.some((c) => c.isFavorite());
    },
    methods: {
      showHideAllCategories() {
        this.showAll = !this.showAll;
      },
      isCategorySelected(categoryId) {
        return this.selectedCategoryId === categoryId;
      },
    },
  };
</script>
